import FirmApi from '../../services/FirmApi'
import { crmService } from '@/services/CrmService'

export const gopay = {
    namespaced: true,
    state: {
        oauth: {
            access_token: null,
            expires_in: null,
            refresh_token: null,
            token_type: null,
        },
        payment: {
            id: 0,
            order_number: 0,
            gw_url: '',
        },
        payment_state: '', // CREATED =	Platba založena, PAID = Platba zaplacena, CANCELED = Platba zrušena https://doc.gopay.com/cs/?lang=php#stavy-plateb
        notification_url: 'https://platba.ci.cz/payment/state/',
    },
    mutations: {
        setOauth(state, oauthData) {
            console.log('oauthData', oauthData)
            state.oauth = oauthData
        },
        setPayment(state, paymentData) {
            state.payment = paymentData
        },
        setPaymentState(state, paymentState) {
            state.payment_state = paymentState
        },
    },
    actions: {
        getToken({ commit, rootState }) {
            return new Promise((resolve, reject) => {
                FirmApi.fetchGopayToken(rootState.config.sandbox)
                    .then(response => {
                        // console.log('response', response)
                        const {
                            access_token,
                            expires_in,
                            refresh_token,
                            token_type,
                        } = response.data.results.response
                        commit('setOauth', {
                            access_token,
                            expires_in,
                            refresh_token,
                            token_type,
                        })

                        resolve(true)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        createPayment({ commit, dispatch, state, rootState }) {
            return new Promise((resolve, reject) => {
                FirmApi.createGopayPayment(
                    rootState.config.crm,
                    rootState.firm.result.id_firmy,
                    rootState.gopay.oauth.access_token,
                    rootState.order.crm.cena * 100, // cena musi byt long v halerich
                    rootState.order.crm.id_historie,
                    rootState.order.crm.cislo_faktury,
                    window.location.href,
                    rootState.gopay.notification_url,
                    rootState.config.sandbox
                )
                    .then(response => {
                        // console.log('response', response)

                        if (response.data.results.status != 200) {
                            dispatch(
                                'loader/setError',
                                'Chyba Gopay ' + response.data.results.status,
                                {
                                    root: true,
                                }
                            )
                            resolve(false)
                        }
                        const {
                            id,
                            order_number,
                            gw_url,
                        } = response.data.results.response
                        commit('setPayment', {
                            id,
                            order_number,
                            gw_url,
                        })
                        resolve(true)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        changePaymentMethod({ commit, rootState }) {
            // return new Promise((resolve, reject) => {
            //     FirmApi.changeOrderPaymentMethod(
            //         rootState.config.crm,
            //         rootState.firm.result.id_firmy,
            //         rootState.firm.result.opravny_kod,
            //         rootState.order.crm.hash_objednavky,
            //         rootState.order.crm.id_historie,
            //         rootState.config.sandbox,
            //         rootState.firm.order_options.payment_method
            //     )
            //     // console.log('response', response)
            //     resolve(true)
            // }).catch(error => {
            //     reject(error)
            // })
            return crmService.getZmenaVybranehoZpusobuPlatby(
                rootState.config.crm,
                rootState.firm.result.id_firmy,
                rootState.firm.result.opravny_kod,
                rootState.order.crm.id_historie,
                rootState.order.crm.hash_objednavky,
                rootState.firm.order_options.payment_method,
                rootState.config.sandbox
            )
        },
        changePaymentStatus({ commit, rootState }, paymentState) {
            // ulozi do store
            commit('setPaymentState', paymentState)

            // ulozi do CRM
            return new Promise((resolve, reject) => {
                FirmApi.changeOrderPaymentStatus(
                    rootState.config.crm,
                    rootState.firm.result.id_firmy,
                    rootState.firm.result.opravny_kod,
                    rootState.order.crm.hash_objednavky,
                    rootState.order.crm.id_historie,
                    rootState.config.sandbox,
                    paymentState
                )
                // console.log('response', response)
                resolve(true)
            }).catch(error => {
                reject(error)
            })
        },
        getState({ rootState, dispatch }) {
            return new Promise((resolve, reject) => {
                FirmApi.fetchGopayState(
                    rootState.gopay.payment.id,
                    rootState.gopay.oauth.access_token,
                    rootState.config.sandbox
                )
                    .then(response => {
                        // console.log('response', response)
                        if (response.data.results.status != 200) {
                            dispatch(
                                'loader/setError',
                                'Chyba Gopay ' + response.data.results.status,
                                {
                                    root: true,
                                }
                            )
                            return false
                        }
                        const { id, state } = response.data.results.response

                        resolve(state)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
    },
}
